export default "__VITE_ASSET__CGV0i8X4__"